import styled from 'styled-components';
import { BORDER_GRAY } from '../../theme';

export const StyledModalContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  width: 1022px;
`;

export const StyledSidebar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  border-right: 1px solid ${BORDER_GRAY};
`;

export const StyledSelectContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;

  // ListBox from MUI needs this...
  & > div {
    width: 100%;
  }
`;
export const StyledMainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  & > div {
    padding: 24px;
  }
`;

export const StyledTimeZoneContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 24px 0;
`;

export const StyledDurationTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 24px 0;
  height: 82px;
  box-sizing: border-box;
`;

export const StyledSessionTimeContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 24px;
`;

export const StyledCalendarContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;
`;
